import {
  SET_ACTIVE_ROLE,
  SET_BUSINESS_IMPORT_MAPPING,
  SET_CURRENT_LIVESTOCKSALE,
} from "constants/actionTypes";

const defaultState = {
  sg8Xml: {
    storedMapping: {},
  },
  auctionsPlusCsv: {
    storedMapping: {},
  },
};

export default function businessImportMappings(state = defaultState, action) {
  switch (action.type) {
    case SET_BUSINESS_IMPORT_MAPPING: {
      const { source, externalCode, businessId } = action;
      const existing = state[source]?.storedMapping || {};
      if (!source || !externalCode || !businessId) {
        return state;
      }

      return {
        ...state,
        [source]: {
          storedMapping: {
            ...existing,
            [externalCode]: { businessId },
          },
        },
      };
    }
    case SET_ACTIVE_ROLE.REQUEST:
    case SET_CURRENT_LIVESTOCKSALE.SUCCESS:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
}
